// extracted by mini-css-extract-plugin
export default {"grid":"salesPersonMapping_grid__okeQM"};